<template>
  <VpFormLayout>
    <template v-slot:content-header>
      <Breadcrumb style="background-color: transparent" :items="items" />
    </template>
    <template v-slot:content-body>
      <AlertFoundActiveSession />

      <div class="timesheet-grid">
        <!-- begin::years select -->
        <vp-multiselect
          class="year-multiselect"
          v-model="yearValue"
          track-by="year"
          label="year"
          :placeholder="$t('common.year')"
          :options="yearDataSource"
          :searchable="false"
          selectLabel=""
          deselectLabel=""
          zIndex="6"
        />
        <!-- end::years select -->

        <!-- begin::months select -->
        <vp-treeselect
          v-model="monthsValue"
          :options="monthsDataSource"
          :placeholder="$t('common.month')"
          :label="$t('common.month')"
          width="415"
        />
        <!-- end::months select -->

        <!-- begin::Sites dropdown -->
        <vp-treeselect
          v-model="sitesValue"
          :options="sites"
          :placeholder="$t('common.site')"
          label="Site"
          width="415"
          @input="updateUsertypesList"
        />
        <!-- end::Sites dropdown -->

        <!-- start::Site note -->
        <p
          v-if="sitesValue.length && !userTypes.length && !getLoaderStatus"
          class="site-note"
        >
          <b>Note:</b> No user types are permitted to enter the selected sites,
          please check again.
        </p>
        <!-- end::Site note -->

        <!-- begin::UserType select -->
        <vp-treeselect
          v-model="userTypeValue"
          :options="userTypes"
          :placeholder="$t('common.userType')"
          label="User Type"
          width="415"
          :isLoading="getLoaderStatus"
          :disabled="
            sitesValue.length <= 0 ||
            getLoaderStatus ||
            (sitesValue.length && !userTypes.length)
          "
        />
        <!-- end::UserType select -->
      </div>
    </template>
    <template v-slot:content-footer>
      <!-- Generate Button -->
      <div class="generate">
        <VpButton
          type="submit"
          :text="$t('common.generate')"
          :class="{
            'disabled-cursor':
              !yearValue ||
              !monthsValue.length ||
              !sitesValue.length ||
              !userTypeValue.length,
          }"
          @click="onGenerateClick"
          :disabled="
            !yearValue ||
            !monthsValue.length ||
            !sitesValue.length ||
            !userTypeValue.length
          "
        />
      </div>
      <!-- Generate Button -->
    </template>
  </VpFormLayout>
</template>

<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";
import AlertFoundActiveSession from "@/components/emergency/AlertFoundActiveSession";
import { mapActions, mapGetters } from "vuex";
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";

export default {
  title: "Timesheet",
  data() {
    let currentYear = moment();
    const yearDataSource = [
      { year: currentYear.year() },
      { year: currentYear.subtract(1, "year").year() },
      { year: currentYear.subtract(1, "year").year() },
      { year: currentYear.subtract(1, "year").year() },
      { year: currentYear.subtract(1, "year").year() },
      { year: currentYear.subtract(1, "year").year() },
    ];

    return {
      isValidForm: false,
      yearValue: null,
      monthsValue: [],
      sitesValue: [],
      userTypeValue: [],
      sites: [],
      userTypes: [],
      monthsDataSource: [],
      yearDataSource,
      items: [
        { text: this.$t('sideNavbarMenu.reporting.text') },
        {
          text: this.$t('sideNavbarMenu.reporting.list.timesheet'),
          active: true,
        },
      ],
    };
  },
  components: {
    AlertFoundActiveSession,
    Breadcrumb,
  },
  watch: {
    getSitesUserTypes(userTypeList) {
      this.userTypes = userTypeList?.map((userType) => {
        if (userType?.children?.length <= 0) {
          delete userType.children;
        }
        return userType;
      });
    },
  },
  methods: {
    ...mapActions("timesheet", ["fetchSitesUserTypes"]),

    async updateUsertypesList(sitesIds) {
      //clear selections on user type treelist
      this.userTypeValue = [];

      //fetch new user type
      if (sitesIds?.length) {
        await this.fetchSitesUserTypes(sitesIds);
      }
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    async onGenerateClick() {
      setTimeout(() => {
        localStorage.removeItem("dx-timesheet-pivotgrid-storing");
      }, 0);
      await this.$store.dispatch("timesheet/prepareTimesheet", {
        year: this.yearValue.year,
        months: this.monthsValue,
        siteIds: this.sitesValue,
        userTypeIds: this.userTypeValue,
      });
      this.$emit("timesheetDataSubmit");
    },
  },
  mounted() {
    setTimeout(() => {
      this.monthsDataSource = [
        { id: 1, label: this.$t('common.months.jan') },
        { id: 2, label: this.$t('common.months.feb')},
        { id: 3, label: this.$t('common.months.mar') },
        { id: 4, label: this.$t('common.months.apr') },
        { id: 5, label: this.$t('common.months.may') },
        { id: 6, label: this.$t('common.months.jun') },
        { id: 7, label: this.$t('common.months.jul') },
        { id: 8, label: this.$t('common.months.aug') },
        { id: 9, label: this.$t('common.months.sep') },
        { id: 10, label: this.$t('common.months.oct') },
        { id: 11, label: this.$t('common.months.nov') },
        { id: 12, label: this.$t('common.months.dec') },
      ];
    }, 0);
    this.$store.dispatch("sites/fetchSites", true).then((res) => {
      //Format sites list to match treeview (label,children)
      const sites = res.data;
      const sitesList =
        sites && sites.length > 0
          ? sites.map((site) => {
              return Object.assign(site, { label: site.name });
            })
          : [];
      this.sites = sitesList?.filter((site) => site.areas_count > 0);
    });
  },
  computed: {
    ...mapGetters("timesheet", ["getSitesUserTypes", "getLoaderStatus"]),
    yearValidationState() {
      return this.yearValue ? true : false;
    },
  },
  created() {
    this.treeBoxValue = [];
  },
};
</script>

<style lang="scss">
.site-note {
  font-size: 14px;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0.25px;
  color: #939393e0;
  width: 415px;
  margin-top: -8px;
}
.usertype-multiselect-container {
  position: relative;
}
.unique-wizard-spinner {
  width: 23px;
  height: 23px;
  position: absolute;
  inset-inline-start: 360px;
  bottom: 17px;
}
.dx-field-label {
  height: 100vh !important;
}
.timesheet-grid {
  background-color: white;
  padding-top: 43px;
  padding-inline-end: 0;
  padding-bottom: 150px;
  padding-inline-start: 40px;
  border-radius: 8px;
}

.disabled-cursor {
  cursor: not-allowed !important;
}

.year-multiselect {
  margin-bottom: 8px !important;
}
</style>
